"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _immutable = _interopRequireDefault(require("immutable"));

var _Constants = require("../../Constants");

var _InfiniteTiles = _interopRequireDefault(require("./InfiniteTiles"));

var _FileDetailContainer = _interopRequireDefault(require("../../containers/browser/FileDetailContainer"));

var _FileRowTile = _interopRequireDefault(require("./FileRowTile"));

var _MediaThumbnailTile = _interopRequireDefault(require("./MediaThumbnailTile"));

var _FolderRowTile = _interopRequireDefault(require("./FolderRowTile"));

var _TileCollection = _interopRequireDefault(require("./TileCollection"));

var noop = function noop() {
  return undefined;
};

var FoldersAndFiles = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(FoldersAndFiles, _Component);

  function FoldersAndFiles(props) {
    var _this;

    (0, _classCallCheck2.default)(this, FoldersAndFiles);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(FoldersAndFiles).call(this, props));
    _this.renderTile = _this.renderTile.bind((0, _assertThisInitialized2.default)(_this));
    _this.renderThumbnail = _this.renderThumbnail.bind((0, _assertThisInitialized2.default)(_this));
    _this.renderFolder = _this.renderFolder.bind((0, _assertThisInitialized2.default)(_this));
    _this.renderFile = _this.renderFile.bind((0, _assertThisInitialized2.default)(_this));
    _this.renderFileDetail = _this.renderFileDetail.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleDrop = _this.handleDrop.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleCloseFileDetail = _this.handleCloseFileDetail.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(FoldersAndFiles, [{
    key: "getRenderer",
    value: function getRenderer(tile) {
      switch (tile.get('type')) {
        case _Constants.CellTypes.FILE:
          return this.renderFile;

        case _Constants.CellTypes.FOLDER:
          return this.renderFolder;

        case _Constants.CellTypes.THUMBNAIL:
          return this.renderThumbnail;

        case _Constants.CellTypes.FILE_DETAIL:
          return this.renderFileDetail;

        default:
          return noop;
      }
    }
  }, {
    key: "handleCloseFileDetail",
    value: function handleCloseFileDetail() {
      var usageTrackingMeta = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var onSelectFile = this.props.onSelectFile;
      onSelectFile(null, usageTrackingMeta);
    }
  }, {
    key: "handleDrop",
    value: function handleDrop(files, folder) {
      var _this$props = this.props,
          type = _this$props.type,
          onDropFiles = _this$props.onDropFiles;
      onDropFiles(files, folder, type);
    }
  }, {
    key: "renderFileDetail",
    value: function renderFileDetail(tile) {
      var onInsert = this.props.onInsert;
      return _react.default.createElement(_FileDetailContainer.default, {
        tile: tile,
        onInsert: onInsert,
        onClose: this.handleCloseFileDetail,
        isReadOnly: this.props.isReadOnly
      });
    }
  }, {
    key: "renderThumbnail",
    value: function renderThumbnail(tile) {
      var image = tile.get('image');
      var _this$props2 = this.props,
          onSelectFile = _this$props2.onSelectFile,
          onInsert = _this$props2.onInsert,
          selectedFileId = _this$props2.selectedFileId,
          isHostAppContextPrivate = _this$props2.isHostAppContextPrivate,
          isUngatedForPreviewThumbnails = _this$props2.isUngatedForPreviewThumbnails;
      var isSelected = Boolean(selectedFileId && selectedFileId === image.get('id'));
      return _react.default.createElement(_MediaThumbnailTile.default, {
        file: image,
        width: 120,
        isSelected: isSelected,
        onSelect: onSelectFile,
        onInsert: onInsert,
        isHostAppContextPrivate: isHostAppContextPrivate,
        isUngatedForPreviewThumbnails: isUngatedForPreviewThumbnails
      });
    }
  }, {
    key: "renderFolder",
    value: function renderFolder(tile) {
      var folder = tile.get('folder');
      var _this$props3 = this.props,
          onSelectFolder = _this$props3.onSelectFolder,
          isReadOnly = _this$props3.isReadOnly,
          disableUpload = _this$props3.disableUpload;
      return _react.default.createElement(_FolderRowTile.default, {
        folder: folder,
        isLast: tile.get('isLast'),
        onSelect: onSelectFolder,
        onDropFiles: this.handleDrop,
        disableUpload: Boolean(disableUpload || isReadOnly)
      });
    }
  }, {
    key: "renderFile",
    value: function renderFile(tile) {
      var _this$props4 = this.props,
          onSelectFile = _this$props4.onSelectFile,
          onInsert = _this$props4.onInsert,
          selectedFileId = _this$props4.selectedFileId,
          uploadingFiles = _this$props4.uploadingFiles,
          isHostAppContextPrivate = _this$props4.isHostAppContextPrivate;
      var file = tile.get('file');
      var fileId = file.get('id');
      var isFileUploading = uploadingFiles.has(fileId);
      var isSelected = Boolean(selectedFileId && selectedFileId === fileId);
      return _react.default.createElement(_FileRowTile.default, {
        file: file,
        isSelected: isSelected,
        isLast: tile.get('isLast'),
        onSelect: onSelectFile,
        onInsert: onInsert,
        isUploading: isFileUploading,
        isHostAppContextPrivate: isHostAppContextPrivate
      });
    }
  }, {
    key: "renderTile",
    value: function renderTile(tile) {
      var renderer = this.getRenderer(tile);
      return renderer(tile);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          tiles = _this$props5.tiles,
          total = _this$props5.total,
          onLoadMoreFiles = _this$props5.onLoadMoreFiles,
          previousSelectedFileId = _this$props5.previousSelectedFileId,
          withPanelNavigator = _this$props5.withPanelNavigator;

      if (withPanelNavigator) {
        return _react.default.createElement(_TileCollection.default, {
          onLoadMoreFiles: onLoadMoreFiles,
          tileRenderer: this.renderTile,
          tiles: tiles,
          total: total,
          previousSelectedFileId: previousSelectedFileId
        });
      }

      return _react.default.createElement(_InfiniteTiles.default, {
        onLoadMoreImages: onLoadMoreFiles,
        tileRenderer: this.renderTile,
        tiles: tiles,
        total: total
      });
    }
  }]);
  return FoldersAndFiles;
}(_react.Component);

FoldersAndFiles.propTypes = {
  type: _propTypes.default.oneOf(Object.keys(_Constants.DrawerTypes)).isRequired,
  tiles: _propTypes.default.instanceOf(_immutable.default.List),
  selectedFileId: _propTypes.default.number,
  total: _propTypes.default.number.isRequired,
  onDropFiles: _propTypes.default.func.isRequired,
  onInsert: _propTypes.default.func.isRequired,
  onLoadMoreFiles: _propTypes.default.func.isRequired,
  onSelectFile: _propTypes.default.func.isRequired,
  onSelectFolder: _propTypes.default.func.isRequired,
  uploadingFiles: _propTypes.default.instanceOf(_immutable.default.Map).isRequired,
  isReadOnly: _propTypes.default.bool.isRequired,
  disableUpload: _propTypes.default.bool.isRequired,
  isHostAppContextPrivate: _propTypes.default.bool.isRequired,
  isUngatedForPreviewThumbnails: _propTypes.default.bool.isRequired,
  withPanelNavigator: _propTypes.default.bool,
  previousSelectedFileId: _propTypes.default.number
};
var _default = FoldersAndFiles;
exports.default = _default;
module.exports = exports.default;